'use strict';

/*
    This file can be used as entry point for webpack!
 */

import $ from 'jquery';
window.$ = window.jQuery = $;

import '@fancyapps/fancybox';
import { sliders } from './plugins/sliders';

import 'components/header/header';
import 'components/intro/intro';
import 'components/modal/modal';
import 'components/webinars/webinars';
import 'components/basic/basic';
import 'components/cart/cart';
import 'components/mak-club/mak-club';
import 'components/forum/forum';
import 'components/article/content/content';
import 'components/article/content/table';
import 'components/lk/lk';
import 'components/online-club/online-club';
import 'components/club-departments/club-departments';
import 'components/training/training';

sliders($('.js-slider'));

$("[data-fancybox]").fancybox({
    helpers: { 
        overlay: {closeClick: true}
    }
})

let $input = $('.form-label').find('input');

$input.each(function(){
    $(this).toggleClass('is-filled', $(this).val().length > 0);
})

$input.on('blur', (e) => {
    $(e.currentTarget).toggleClass('is-filled', $(e.currentTarget).val().length > 0);
});

$(document).on('click', '.js-link-smooth', (event) => {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($(event.currentTarget).attr('href')).offset().top
    }, 500);
});